import '../styles/Navbar.css';
export default function Navbar() {
    return (
        <nav className="nav">
            <div className='nav__container'>
                <ul className='nav__links'>
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About</a></li>
                    <li><a href="#projects">Projects</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
            </div>
        </nav>
    )
}